import React from 'react';

import WarningTooltipDialog from 'components/Pages/Admin/Itinerary/Details/DetailsChronologicalMode/Event/ModalContents/TooltipDialog';
import { ISelectOption } from 'components/shared/BaseFormComponents/Select/types';
import Button from 'components/shared/Button';

import { useAccomodationFormContext } from '../AccomodationForm/hooks';
import { openPagePreview } from '../functions';
import { usePropertyData } from '../hooks';
import s from './index.module.css';
import { SuggestedAreaPromt } from './SuggestedAreaPromt';
import { TooltipDialog } from './TooltipDialog';

const AddToItineraryButton = function () {
  const [isPreviewActive, setPreviewActive] = React.useState(false);

  const { isDisabled, goToOwnedArea, submitForm, goToSuggestedArea, methods } = useAccomodationFormContext();

  const attachedPageId = methods.watch('attachedPage.id');
  const { activeAreaPage, isLoading } = usePropertyData({ pageId: attachedPageId });

  const handlePagePreview = async (pageId: ISelectOption['id']) => {
    setPreviewActive(true);
    try {
      await openPagePreview(pageId);
    } finally {
      setPreviewActive(false);
    }
  };

  const handleSubmitSuggestArea = (type: 'yes' | 'no' | 'choose-own') => {
    if (type === 'yes') return goToSuggestedArea();
    if (type === 'choose-own') return goToOwnedArea();
    submitForm();
  };

  return (
    <TooltipDialog
      closeOnOutsideClick={!isPreviewActive}
      content={
        <SuggestedAreaPromt
          areaPage={activeAreaPage}
          onSubmit={handleSubmitSuggestArea}
          onPagePreview={handlePagePreview}
        />
      }
      containerClassName={s.toooltipContainer}
    >
      <Button disabled={isDisabled} loading={isLoading} size="large" htmlType="button">
        Add To Itinerary
      </Button>
    </TooltipDialog>
  );
};

export const SaveButton = function () {
  const { isDisabled, submitForm, isOverideWarning, methods, isEditing } = useAccomodationFormContext();

  const propertyPageId = methods.watch('attachedPage.id');
  const { isValidPropertyPage } = usePropertyData({ pageId: propertyPageId });

  if (isOverideWarning) {
    return (
      <WarningTooltipDialog
        onSubmit={submitForm}
        text={'Updating the Content Page here will overwrite\nthe changes you had made within the itinerary.'}
        cancelButtonText="Cancel"
        confirmButtonText="Confirm"
      >
        <Button disabled={isDisabled} size="large" htmlType="button">
          Update
        </Button>
      </WarningTooltipDialog>
    );
  }

  if (isEditing) {
    return (
      <Button disabled={isDisabled} size="large" htmlType="button" onClick={submitForm}>
        Update
      </Button>
    );
  }

  if (isValidPropertyPage) return <AddToItineraryButton />;

  return (
    <Button disabled={isDisabled} size="large" htmlType="button" onClick={submitForm}>
      Add To Itinerary
    </Button>
  );
};
